import { render } from "./ProsesSubKategori.vue?vue&type=template&id=4c238738"
import script from "./ProsesSubKategori.vue?vue&type=script&lang=js"
export * from "./ProsesSubKategori.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__